export default "__VITE_ASSET__D9qS4ak0__"